<!-- Toolbar -->
<app-nav-bar></app-nav-bar>
<main>
    <router-outlet></router-outlet>
</main>
<!-- Footer -->
<app-footer></app-footer>



